<template>
  <base-legal-page
    kicker="Total Chaos"
    title="Total Chaos - Support"
  >
    <p>We're here to help you get the most out of Total Chaos.</p>

    <h2>About Total Chaos</h2>
    <p>
      Total Chaos is the ultimate party games app. Play games like Know Me, Lie Detector, 1v1 Trivia, Fill the Blank, and more with your friends. Create a game, invite your friends, and enjoy hours of fun together.
    </p>

    <h2>Frequently Asked Questions</h2>

    <p><strong>How do I create a game?</strong></p>
    <p>
      Open the app, select a game mode, enter your name, and tap "Create Game." Share the game code with your friends so they can join.
    </p>

    <p><strong>How do I join a game?</strong></p>
    <p>
      Tap "Join with Code" on the home screen and enter the game code shared by the host.
    </p>

    <p><strong>Can I play offline?</strong></p>
    <p>
      Some game modes support Airplane Mode for local play without an internet connection. Look for the Airplane Mode option on the home screen.
    </p>

    <p><strong>How many players can join a game?</strong></p>
    <p>
      The number of players depends on the game mode. Most modes support groups of friends for the best party experience.
    </p>

    <p><strong>The app is crashing or not working properly. What should I do?</strong></p>
    <p>Please try the following steps:</p>
    <ul>
      <li>Make sure you have the latest version of the app installed</li>
      <li>Restart the app</li>
      <li>Restart your device</li>
      <li>Check your internet connection</li>
    </ul>
    <p>If the issue persists, please contact us using the information below.</p>

    <h2>Contact Us</h2>
    <p>
      If you need further assistance or have any questions, feedback, or concerns, please reach out to us:
    </p>
    <div class="hh-legal__contact">
      <div><strong>Email:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Website:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'TotalChaosSupport',

    metaInfo: { title: 'Total Chaos Support' },
  }
</script>
